export default "__VITE_PUBLIC_ASSET__03090b8d__"